import { isRequired } from '@gef-ui/form-core/validations/validationFunctions/common';

import { COMMON_FORM_FIELD_NAMES } from 'features/common/forms/constants';

export const MARKET_PLACE_AGENCIES_SETTINGS_FORM_NAME = 'marketPlace-agencies-settings';

const { region } = COMMON_FORM_FIELD_NAMES;

export const FIELDS = {
	region,
	segment: 'segment',
};

export default () => ({
	[FIELDS.region]: {
		deepPath: [FIELDS.region],
		validations: [isRequired()],
	},
	[FIELDS.segment]: {
		deepPath: [FIELDS.segment],
		validations: [isRequired()],
	},
});
